import { ScrollView, StyleSheet, View } from "react-native";
import React, { useMemo, useState } from "react";
import { useSizeClass } from "../../../common/Utils/useSizeClass";
import { SizeClass } from "@/src/common/Utils/SizeClass";

import { useDeviceOrientation } from "../../../common/Utils/useDeviceOrientation";
import { LazyQueryNetworkBoundrary } from "../../../components/mobile/QueryNetworkBoundrary";
import { graphql, useLazyLoadQuery } from "react-relay";
import { RoutineOccasionFollowupQuery } from "./__generated__/RoutineOccasionFollowupQuery.graphql";
import { RoutineOccasionFollowupOccasionList } from "./RoutineOccasionFollowupOccasionList";
import { RoutineOccasionFollowupSections } from "./RoutineOccasionFollowupSections";
import { RoutineDetailNavigatorScreenProps } from "../RoutineDetail/RoutineDetailStack";

function InnerRoutineOccasionFollowup(props: {
  fetchKey: string;
  width: number;
  itemWidth: number;
  numberOfItems: number;
  routineId: string;
}) {
  const data = useLazyLoadQuery<RoutineOccasionFollowupQuery>(
    graphql`
      query RoutineOccasionFollowupQuery(
        $id: ID!
        $after: String
        $first: Int
        $endAt: String
        $startAt: String
      ) {
        routine(id: $id) {
          ...RoutineOccasionFollowupOccasionList_routine
          ...RoutineOccasionFollowupSections_routine
        }
      }
    `,
    {
      id: props.routineId,
      first: props.numberOfItems * 2,
    },
    { fetchKey: props.fetchKey, fetchPolicy: "store-and-network" }
  );
  if (!data.routine) {
    return null;
  }

  return (
    <ScrollView>
      <View
        style={{
          ...StyleSheet.absoluteFillObject,
          position: "absolute",
          top: 50,
        }}
      >
        <RoutineOccasionFollowupSections routine={data.routine} />
      </View>
      <RoutineOccasionFollowupOccasionList
        width={props.width}
        itemWidth={props.itemWidth}
        numberOfItems={props.numberOfItems}
        routine={data.routine}
      />
    </ScrollView>
  );
}

export const RoutinesOccasionsFollowupScreen = (
  props: RoutineDetailNavigatorScreenProps<"RoutinesOcassionsFollowup">
) => {
  const numberOfItems = useSizeClass().width === SizeClass.COMPACT ? 7 : 14;
  useDeviceOrientation();
  const { route } = props;
  const id = route?.params?.routineId;

  const [width, setWidth] = useState(0);
  const itemWidth = useMemo(
    () => Math.floor(width / numberOfItems),
    [width, numberOfItems]
  );

  return (
    <View
      onLayout={(l) => {
        setWidth(l.nativeEvent.layout.width);
      }}
    >
      <LazyQueryNetworkBoundrary newFetchKeyOnNavigation>
        {(fetchKey) => (
          <InnerRoutineOccasionFollowup
            fetchKey={fetchKey}
            itemWidth={itemWidth}
            numberOfItems={numberOfItems}
            routineId={id}
            width={width}
          />
        )}
      </LazyQueryNetworkBoundrary>
    </View>
  );
};
